// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAeTfzrGPRV5fB1wGo1n64d7ALmFKrEtAg",
  authDomain: "impresion-veloz-8ef69.firebaseapp.com",
  projectId: "impresion-veloz-8ef69",
  storageBucket: "impresion-veloz-8ef69.firebasestorage.app",
  messagingSenderId: "708320710259",
  appId: "1:708320710259:web:be12e9f33d3d7381a8a406",
  measurementId: "G-LLB94GCL0Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Firebase Analytics cargaba un TERCER contenedor GA4 (el measurementId de
// abajo apunta a la propiedad que Firebase crea automáticamente) y la
// variable no se usaba en ninguna parte. La medición va por gtag en
// index.html y por GTM, ambos hacia G-G21SXG8Y5F.
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
